import { SET_SCREEN, appScreens, SET_SCREEN_VERANSTALTUNG, SET_SCREEN_DRUCKANSICHT, druckVarianten,
	DISPLAY_DIALOG_QRCODE_LINK_TO_APP, SET_DISPLAY_MODE,
	SET_SAVE_STATE_TO_LOCAL_STORAGE } from "./actions";
import { DISPLAY_MODE_AUTO } from "../../displayMode";

const initialState = {
	currentScreen : appScreens.startPage,
	selectedVNR : "",
	saveStateToLocalStorage : false,
	displayDialogQrcodeLinkToApp: false,
	// 'auto' | 'light' | 'dark' - liegt hier, weil der Store ohnehin nur dann im
	// Browser landet, wenn der Anwender die lokale Speicherung eingeschaltet hat.
	displayMode: DISPLAY_MODE_AUTO,
	druckVariante: druckVarianten.anwesenheitsliste
}
export const appNavigationReducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_SCREEN:
			return  {...state, currentScreen : action.payload}
		case DISPLAY_DIALOG_QRCODE_LINK_TO_APP:
			return  {...state, displayDialogQrcodeLinkToApp : action.payload}
		case SET_SCREEN_VERANSTALTUNG:
			return  {...state, 
				currentScreen : appScreens.veranstaltungPage,
				selectedVNR : action.payload
			}
		case SET_SCREEN_DRUCKANSICHT:
			return  {...state,
				currentScreen : appScreens.druckansichtPage,
				druckVariante : action.payload
			}
		case SET_SAVE_STATE_TO_LOCAL_STORAGE:
			return  {...state, saveStateToLocalStorage : action.payload}
		case SET_DISPLAY_MODE:
			return  {...state, displayMode : action.payload}

		default:
			return state;
	}
}
